<template>
  <h1>MyFeed</h1>
  <div class="container" v-if="loading">
    <strong>{{ $gettext('Cerco le ricette..') }}</strong>
  </div>

  <div class="container" v-if="!loading && listing.length === 0">
    <strong>{{ $gettext('Segui gli utenti della community per veder qui le loro ultime ricette inserite') }}</strong>
  </div>

  <div class="recipes container" v-if="!loading">
    <recipe-card-users
      v-for="item in listing"
      :key="item.id"
      :title="item.title"
      :image="item.image"
      :id="item.id"
      :category="item.categoria"
      :authorId="item.authorId"
      :authorName="item.authorName"
    ></recipe-card-users>
  </div>
</template>

<script>
import recipeCardUsers from '@/components/recipe/RecipeCardUsers';

export default {
  name: 'myfeed',
  components: { recipeCardUsers },

  data() {
    return {
      listing: [],
      filterBy: '',
      filterCategory: [],
      loading: false,
    };
  },
  methods: {
    loadMachine() {
      this.loading = true;
      const config = {
        headers: {
          Authorization: 'Bearer ' + this.$store.getters['auth/getToken'],
        },
      };

      const params = {
        myfeed: 1,
      };

      let url = this.api.getRecipeListing+"&myfeed=1&" + this.$store.getters['auth/getLanguageRest'];

      if (this.filterBy > 0) {
        url = url + '&categoria_ricetta=' + this.filterBy;
      }

      this.listing = [];
      this.axios
        .get(url, config)
        .then((response) => {
          const listing = [];

          response.data.forEach((item, index) => {
            if (item.author == 1) {
              item.author_name = "Sirman";
            }

            listing.push({
              authorName: item.author_name,
              authorId: item.author,
              id: item.id,
              title: item.title.rendered,
              image: '/images/placeholder-768x768.png',
              categoria: this.getCategoryName(item.categoria_ricetta[0]),
              item: item,
            });

            this.loadImageURL(item.featured_media, index);
          });

          this.listing = listing;
          this.loading = false;
        })
        .catch((error) => {
          console.log('Error: ' + error);
        });
    },
    loadCategories() {
      this.axios
        .get(this.api.categoriesRecipe+"?" + this.$store.getters['auth/getLanguageRest'])
        .then((res) => {
          const categories = [];

          for (const data of res.data) {
            categories.push({
              id: data.id,
              name: data.name,
            });
          }

          this.filterCategory = categories;
        })
        .catch((err) => {
          console.log('Error: ' + err);
        });
    },
    getCategoryName(id) {
      let name = '';
      this.filterCategory.forEach((item) => {
        if (item.id == id) name = item.name;
      });
      return name;
    },
    async loadImageURL(idM, idListing) {

      let mediaUrl = this.api.getMediaUrl + idM;

      await fetch(mediaUrl)
        .then(function (response) {
          if (response.ok) {
            return response.json();
          } else {
            console.log('Error in loading image');
          }
        })
        .then((res) => {
          this.listing[idListing].image =
            res.media_details.sizes.medium_large.source_url;
        })
        .catch((err) => {
          console.log('Error: ' + err);
        });
    },

    filter() {
      this.loadMachine();
    },
  },

  mounted() {
    console.log("isLoggedIn");
    console.log(this.$store.getters['auth/isLoggedIn']);
    if (!this.$store.getters['auth/isLoggedIn']) {
      this.$router.replace('/');
      return;
    }

    if (typeof this.$router.currentRoute.value.params.id != 'undefined') {
      this.filterBy = this.$router.currentRoute.value.params.id;
    }

    this.loadCategories();
    this.loadMachine();
  },
};
</script>

<style scoped>
h1 {
  font-size: 1.5em;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 4px;
}
.recipes.container {
  width: 90%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: 0 auto 30px;
  padding: 0;
}
</style>
